import { FC } from 'react'
import { Col, Row } from 'react-grid-system'
import styled from 'styled-components'
import { NormalFormSelectionField, NormalFormTextArea, NormalFormTextField } from '../molecules'
import { useUserLanguage } from '@/customHooks/useUserLanguage'
import textsData from '@/textData/AddNewIncidentModalTexts.json'
import { Button, UploadButton } from '../atoms'

const categories = [
  {
    value: "electricidad",
    name: "Electricidad"
  },
  {
    value: "plomeria",
    name: "Plomería"
  },
  {
    value: "albañil",
    name: "Albañilería"
  },
  {
    value: "pintura",
    name: "Pintura"
  },
]

const incidentType = [
  {
    value: "reparacion",
    name: "Reparación"
  },
  {
    value: "instalacion",
    name: "Instalación"
  },
]

const FormWrapper = styled.form`
  & > legend {
    font-size: ${({ theme }) => theme.typography.fontSize.s4};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    margin-bottom: 2.5rem;
  }
`

const ButtonBox = styled(Col)`
  display: flex;
  gap: ${({ theme }) => theme.spacing.lg};
  justify-content: center;
  align-items: center;
  & > button {
    font-weight: 500;
    min-width: 200px;
  }
`
export const AddNewIncidentForm: FC = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  return (
    <FormWrapper>
      <legend>{texts.title}</legend>
      <Row>
        <Col md={6}>
          <NormalFormSelectionField
            label={texts.form.type}
            name={texts.form.type.toLocaleLowerCase().replace(' ', '-')}
            options={incidentType}
            action={(value) => console.log(value)}
          />
        </Col>
        <Col md={6}>
          <NormalFormSelectionField
            label={texts.form.category}
            name={texts.form.category.toLocaleLowerCase().replace(' ', '-')}
            options={categories}
            action={(value) => console.log(value)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormTextField
            placeholder={texts.form.subjectPlaceholder}
            name={texts.form.subject.toLowerCase()}
            action={(value) => console.log(value)}
            label={texts.form.subject}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormTextArea
            placeholder={texts.form.description}
            name={texts.form.description.toLowerCase()}
            action={(value) => console.log(value)}
            label={texts.form.description}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <UploadButton name="file" label={texts.form.upload}/>
        </Col>
      </Row>
      <Row>
        <ButtonBox>
          <Button
            onClick={() => console.log('boton presionado')}
            secondary
          >
            {texts.form.buttons.cancel}
          </Button>
          <Button
            onClick={() => console.log('confirm')}
          >
            {texts.form.buttons.confirm}
          </Button>
        </ButtonBox>
      </Row>
    </FormWrapper>
  )
}